import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-24 px-4 py-16 md:px-6 md:py-24">
      <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
        <i className="ri-question-answer-fill"></i>
        常见问题
      </span>
      <h2 className="mt-3 font-display text-3xl font-black text-foreground-900 md:text-4xl">
        关于吃瓜快手，你想知道的都在这里
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-500 md:text-base">
        有梗、有料，也讲规矩。下面这些问题没准能帮你更快地在瓜田里驰骋。
      </p>

      <div className="mt-8 space-y-3">
        {faqItems.map((item, idx) => {
          const open = openIdx === idx;
          return (
            <div
              key={idx}
              className={`overflow-hidden rounded-2xl border transition-colors ${
                open ? "border-primary-200 bg-primary-50/50" : "border-background-200 bg-background-50"
              }`}
            >
              <button
                onClick={() => setOpenIdx(open ? null : idx)}
                aria-expanded={open}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
              >
                <span className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                    open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm leading-7 text-foreground-600 md:px-6">{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}